import AsyncStorage from '@react-native-async-storage/async-storage';
export class LocalStorage {
  async get(key) {
    return await AsyncStorage.getItem(key);
  }

  async put(key, value) {
    await AsyncStorage.setItem(key, value);
    return;
  }

  async delete(key) {
    await AsyncStorage.removeItem(key);
    return;
  }

}
//# sourceMappingURL=local-storage.js.map